import AdditionalSwatchSelector from './AdditionalSwatchSelector';

export default AdditionalSwatchSelector;
